import { render, staticRenderFns } from "./MarkdownDisplay.vue?vue&type=template&id=6d23b5f6"
import script from "./MarkdownDisplay.vue?vue&type=script&lang=js"
export * from "./MarkdownDisplay.vue?vue&type=script&lang=js"
import style0 from "./MarkdownDisplay.vue?vue&type=style&index=0&id=6d23b5f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports